function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsWheelFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "settings_wheel_full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.612 5.858a.767.767 0 0 1-.239.865l-1.153.988a1.211 1.211 0 0 0-.407.981c0 .1.007.2.007.309s0 .207-.007.309a1.191 1.191 0 0 0 .407.981l1.153.988a.767.767 0 0 1 .239.865 8.489 8.489 0 0 1-.589 1.206l-.175.285a8.971 8.971 0 0 1-.824 1.1.878.878 0 0 1-.914.239l-1.481-.443a1.383 1.383 0 0 0-1.108.162 6.783 6.783 0 0 1-.563.306 1.27 1.27 0 0 0-.7.823l-.332 1.431a.822.822 0 0 1-.679.626 10.271 10.271 0 0 1-3.17 0 .822.822 0 0 1-.679-.626l-.334-1.433a1.26 1.26 0 0 0-.7-.823c-.194-.095-.38-.2-.563-.306a1.381 1.381 0 0 0-1.108-.162l-1.477.447a.885.885 0 0 1-.914-.239 8.971 8.971 0 0 1-.824-1.1l-.178-.282a8.489 8.489 0 0 1-.589-1.206.767.767 0 0 1 .239-.865L2.1 10.3a1.211 1.211 0 0 0 .407-.981c0-.1-.007-.2-.007-.309s0-.207.007-.309a1.191 1.191 0 0 0-.407-.986L.951 6.723a.767.767 0 0 1-.239-.865A8.489 8.489 0 0 1 1.3 4.652l.175-.285A8.97 8.97 0 0 1 2.3 3.27a.878.878 0 0 1 .914-.239l1.486.443a1.383 1.383 0 0 0 1.1-.162c.183-.109.369-.214.563-.306a1.27 1.27 0 0 0 .7-.823L7.4.752a.822.822 0 0 1 .679-.625A9.8 9.8 0 0 1 9.664 0a10.21 10.21 0 0 1 1.585.123.822.822 0 0 1 .679.626l.332 1.431a1.25 1.25 0 0 0 .7.823c.194.095.38.2.563.306a1.4 1.4 0 0 0 1.108.162l1.481-.443a.885.885 0 0 1 .914.239 8.97 8.97 0 0 1 .824 1.1l.175.285a8.489 8.489 0 0 1 .589 1.206zm-8.948 5.957A2.9 2.9 0 0 0 12.648 9a2.9 2.9 0 0 0-2.984-2.811A2.9 2.9 0 0 0 6.68 9a2.9 2.9 0 0 0 2.984 2.813z",
    transform: "translate(2.338 3)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWheelFull);
export default __webpack_public_path__ + "static/media/settings_wheel_full.bd2bad562308fcf866b321072c004cec.svg";
export { ForwardRef as ReactComponent };